import React from 'react';
import { COLOR } from '../../styles';
import { type SolinkLogoProps } from './SVG.types';

const SolinkLogo: React.FC<SolinkLogoProps> = ({
  arcColor = COLOR['white'],
  circleColor = COLOR['white'],
  height = '32px',
  width = '32px',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 26 25"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="solink-logo" fillRule="nonzero">
      <path
        className="arc"
        d="M16.88667,17.411 L21.05467,21.6096 C17.43597,24.7043 12.35447,25.3796 8.06267,23.3362 C8.21767,22.8661 8.29642,22.37391 8.29588,21.8786 C8.29560539,19.3669 6.27418,17.3309 3.78078,17.3309 C3.2852,17.3320861 2.793,17.413087 2.32278,17.57084 C0.28078,13.24204 0.94688,8.10954 4.02488,4.45484 L8.18788,8.64794 C6.39088,11.14464 6.66148,14.58674 8.82616,16.76744 C10.99086,18.94814 14.40776,19.22094 16.88646,17.41087 L16.88667,17.411 Z"
        fill={arcColor}
      ></path>
      <path
        className="arc"
        d="M25.42367,12.42 C25.4280687,15.3063 24.40967,18.0995 22.55167,20.2968 L18.38467,16.0993 C20.18187,13.6031 19.91147,10.1614 17.74697,7.981 C15.58247,5.8006 12.16577,5.5283 9.68777,7.33863 L5.52077,3.14113 C9.11987,0.06513 14.16637,-0.62107 18.44677,1.38343 L18.44677,1.3889386 C17.86172,2.7935386 18.01265,4.3998386 18.84895,5.6690386 C19.68525,6.9381386 21.09615,7.7020386 22.60835,7.7043386 C23.19972,7.7063574 23.78555,7.5893886 24.33145,7.3602986 C25.05531,8.9472986 25.42815,10.6736986 25.42415,12.4201986 L25.42367,12.42 Z"
        fill={arcColor}
      ></path>
      <path
        className="circle"
        d="M17.65667,12.255 C17.6611974,13.7496 16.88263,15.1396 15.60007,15.9264 C14.90815,16.35902 14.10607,16.58721 13.28797,16.58421 C10.87497,16.58421 8.91877,14.64601 8.91877,12.25501 C8.91794245,9.86291 10.87377,7.92281 13.28797,7.92091 C14.44747,7.92117188 15.55937,8.37806 16.37877,9.19101 C17.19816,10.00392 17.65787,11.10621 17.65667,12.25511 L17.65667,12.255 Z"
        fill={circleColor}
      ></path>
      <path
        className="circle"
        d="M6.97737,21.905 C6.97752909,22.15263 6.94592,22.39929 6.883288,22.63918 C6.516998,24.11398 5.113388,25.10998 3.570488,24.98998 C2.027588,24.86996 0.801688,23.66938 0.676988,22.15638 C0.552348,20.64338 1.565858,19.26538 3.069088,18.90398 C3.315458,18.842797 3.568618,18.811804 3.822768,18.811709 C5.564468,18.8125344 6.976168,20.196909 6.977368,21.905009 L6.97737,21.905 Z"
        fill={circleColor}
      ></path>
      <path
        className="circle"
        d="M25.66667,3.0946 C25.6674001,4.3852 24.87468,5.5399 23.67987,5.9886 C23.33898,6.12163 22.97664,6.18931 22.61137,6.18818 C22.51098,6.18847961 22.41066,6.1831492 22.31086,6.172213 C22.21851,6.1655994 22.12688,6.151078 22.03695,6.128804 C20.61755,5.832634 19.59895,4.567004 19.59885,3.099104 C19.5965651,2.732884 19.662241,2.369494 19.79246,2.027804 C20.19125,0.917304 21.18216,0.135704 22.34286,0.016004 C22.432272,0.00503 22.52227,-0.000303 22.61234,3.7e-05 C22.71633,-0.00025804 22.82026,0.0050718 22.92369,0.016004 C24.48139,0.179524 25.66549,1.508404 25.66669,3.094604 L25.66667,3.0946 Z"
        fill={circleColor}
      ></path>
    </g>
  </svg>
);

// Display Name
SolinkLogo.displayName = 'SolinkLogo';

export default SolinkLogo;
